import RenderIf from '../../../components/render-if/Renderif';
import { getSafeExternalUrl } from '../../../utils/securityUtil';

const exhibitsGridClasses =
    "grid grid-cols-[repeat(auto-fill,minmax(80px,1fr))] gap-1.5";

const exhibitLinkClasses =
    "block text-center py-1 px-1.5 rounded-md bg-primary-surface " +
    "text-primary text-xs font-medium no-underline whitespace-nowrap " +
    "hover:bg-primary-surface";

export default function ChatProof({ message }) {
    const hasExhibits = message.exhibitSignedUrls && message.exhibitSignedUrls.length > 0;
    return (
        <RenderIf shouldRender={hasExhibits} >
            <div className="mt-2 text-[0.9em]">
                <div className="flex items-center gap-1 mb-1.5">
                    <span role="img" aria-label="check">✅</span>
                    <span>Sources:</span>
                </div>
                <div className={exhibitsGridClasses}>
                    {message?.exhibitSignedUrls?.map((exhibit, index) => (
                        <a
                            href={getSafeExternalUrl(exhibit, '#')}
                            target="_blank"
                            rel="noopener noreferrer"
                            key={`exhibit${index}`}
                            className={exhibitLinkClasses}
                            onClick={(e) => {
                                if (!getSafeExternalUrl(exhibit, null)) {
                                    e.preventDefault();
                                    console.error('Invalid exhibit URL blocked:', exhibit);
                                }
                            }}
                        >
                            Exhibit {index + 1}
                        </a>
                    ))}
                </div>
            </div>
        </RenderIf>
    );
}
